import { readable } from "svelte/store";

export const configStore = readable({
  titulka: "ŠFRB | Smartmap v4", // zobrazi sa v nazve tabu - <title>
  pociatocne_pozicie: {
    lat: 48.697,
    lng: 19.682,
    zoom: 7,
  },
  pociatocne_vrstvy: [
    {
      kod: "zbgis-2022",
      typ: "raster",
      kodUrl: "zbgis-2022",
    },
  ],
  map: {
    maxZoom: 15.49,
    minZoom: 7,
  },
  sources: {
    maxzoom: 15.49,
    minzoom: 7,
  },
  layers: {
    maxzoom: 16,
    minzoom: 7,
  },
  /**
   * FARBY
   */
  farby: [
    { kod: "001", html_kod: "008800" }, // adresy
    { kod: "002", html_kod: "6755cc" }, // clv
    { kod: "003", html_kod: "a55063" }, // dane
    { kod: "004", html_kod: "256326" }, // eparcely
    { kod: "005", html_kod: "36493e" }, // kamery
    { kod: "006", html_kod: "13ec1a" }, // komposter
    { kod: "007", html_kod: "5ee03e" }, // kompostermeno
    { kod: "008", html_kod: "403585" }, // komunikacie
    { kod: "009", html_kod: "496240" }, // komunikaciechodnik
    { kod: "010", html_kod: "377514" }, // komunikacieine
    { kod: "011", html_kod: "973269" }, // komunikacieparkoviska
    { kod: "012", html_kod: "675822" }, // komunikacieschodisko
    { kod: "013", html_kod: "342860" }, // komunikaciezelen
    { kod: "014", html_kod: "747dbe" }, // kose
    { kod: "015", html_kod: "5b737d" }, // ku
    { kod: "016", html_kod: "7e8d18" }, // lampy
    { kod: "017", html_kod: "8c703b" }, // lavicky
    { kod: "018", html_kod: "db6d00" }, // obyvatelia
    { kod: "019", html_kod: "837f11" }, // osvetlenie
    { kod: "020", html_kod: "424242" }, // parcely
    { kod: "021", html_kod: "618acc" }, // parkoviska
    { kod: "022", html_kod: "939137" }, // psy
    { kod: "023", html_kod: "4f3d30" }, // rozhlas
    { kod: "024", html_kod: "24bafc" }, // rozhodnutia
    { kod: "025", html_kod: "25bafc" }, // rozhodnutianazov
    { kod: "026", html_kod: "157601" }, // rozhodnutiaparcely
    { kod: "027", html_kod: "2b6822" }, // rvo
    { kod: "028", html_kod: "863068" }, // semafory
    { kod: "029", html_kod: "a6428a" }, // smeti
    { kod: "030", html_kod: "b73850" }, // stojiska
    { kod: "031", html_kod: "4ea659" }, // stromy
    { kod: "032", html_kod: "000088" }, // ulice
    { kod: "033", html_kod: "6755cc" }, // vlastnici
    { kod: "034", html_kod: "31439b" }, // znacky

    // vyhladavania
    { kod: "101", html_kod: "008800" }, // Adresy, ulice, k.ú.
    { kod: "102", html_kod: "6755CC" }, // Osoba, firma
    { kod: "103", html_kod: "654380" }, // Pes, majiteľ
    { kod: "104", html_kod: "675534" }, // Parcely a L.V.
    { kod: "105", html_kod: "21BBEF" }, // Rozhodnutia
    { kod: "106", html_kod: "793028" }, // RVO, stromy, lavičky a koše, stojisko, lampy
    { kod: "107", html_kod: "185780" }, // Dopravné značenie, parkoviská, osvetlenie, rozhlas, kamery, semafóry
    { kod: "108", html_kod: "888035" }, // Doprava
    { kod: "109", html_kod: "d21717" }, // Rozkopavky

    // selecty
    { kod: "201", html_kod: "000088" }, // Ulice
    { kod: "202", html_kod: "5b737d" }, // Katastrálne úzenia

    // rozkopavky
    { kod: "301", html_kod: "8700ff" }, // rozkopavka
    { kod: "302", html_kod: "20e852" }, // v zaruke
    { kod: "303", html_kod: "ffbf00" }, // konci zaruka
    { kod: "304", html_kod: "ff0000" }, // skoncila zaruka
    { kod: "305", html_kod: "000000" }, // deleted_at
  ],
  /**
   * VYHLADAVANIE
   */
  vyhladavania: {
    typy: [
      {
        id: 16,
        nazov: "ID žiadosti, žiadateľ, názov, zhotoviteľ",
        placeholder:
          "Zadajte ID žiadosti, žiadateľa, názov stavby, zhotoviteľa",
        typy: ["cislo_ziadosti", "ziadatel", "nazov_stavby", "zhotovitel"],
        kod_ikonky: "001",
        kod_farby: "102",
      },
      {
        id: 1,
        nazov: "Kraj, okres, obec",
        placeholder: "Zadajte názov kraju, okresu, obce",
        typy: ["kraj", "okres", "obec"],
        kod_ikonky: "001",
        kod_farby: "101",
      },
    ],
  },
  /**
   * SELECTY
   */
  selecty: [],
  /**
   * TYPY
   */
  typy: [
    // systemove
    {
      nazov: "Point",
      kod: ["point", "dblclick"],
      kod_farby: "006",
      kod_ikonky: "",
      hrubka_ciary: 1,
      nastavenie_mapy: [
        {
          typ_vrstvy: "symbol",
          layout: {
            "icon-image": "marker",
            "icon-anchor": "bottom",
            "icon-offset": [0, 5],
            "icon-allow-overlap": true,
          },
          paint: {
            "icon-color": "#144672",
            "icon-halo-color": "#ffffff",
            "icon-halo-width": 5,
          },
        },
      ],
    },
    {
      nazov: "Polygon",
      kod: "polygon",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": "#3388ff",
            "fill-outline-color": "#3388ff",
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "LineString",
      kod: "linestring",
      kod_farby: "003",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": "#3388ff",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },

    // geo typy
    {
      nazov: "Kraj",
      kod: "kraj",
      kod_farby: "004",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "Obec",
      kod: "obec",
      kod_farby: "005",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "Okres",
      kod: "okres",
      kod_farby: "006",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "KÚ",
      kod: "ku",
      kod_farby: "015",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },

    {
      nazov: "Číslo žiadosti",
      kod: "cislo_ziadosti",
      kod_farby: "010",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "Názov stavby",
      kod: "nazov_stavby",
      kod_farby: "011",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "Žiadateľ",
      kod: "ziadatel",
      kod_farby: "007",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },
    {
      nazov: "Zhotoviteľ",
      kod: "zhotovitel",
      kod_farby: "008",
      kod_ikonky: "",
      nastavenie_mapy: [
        {
          typ_vrstvy: "fill",
          paint: {
            "fill-color": `%kod_farby%`,
            "fill-outline-color": `%kod_farby%`,
            "fill-opacity": 0.2,
          },
        },
        {
          typ_vrstvy: "line",
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": `%kod_farby%`,
            "line-width": 4,
            "line-opacity": 0.7,
          },
        },
      ],
    },

    // typy bez geo
    {
      nazov: "Žiadosti",
      kod: "ziadosti",
      kod_farby: "008",
      kod_ikonky: "084",
    },
    {
      nazov: "Žiadosti - info",
      kod: "ziadosti_info",
      kod_farby: "009",
      kod_ikonky: "084",
    },
    {
      nazov: "Parcely",
      kod: "parcely",
      kod_farby: "020",
      kod_ikonky: "006",
    },

    // vektorove
    {
      nazov: "SK kraj",
      kod: ["vkraje"],
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 3,
            "line-color": "#dd3e3e",
          },
          minzoom: 7,
          filter: ["==", "$type", "Polygon"],
          koddb: "kraj",
        },
        /* {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 16,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
            "text-allow-overlap": true,
          },
          paint: {
            "text-color": "#dd3e3e",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 7,
          koddb: "nazov",
        }, */
      ],
    },
    {
      nazov: "SK obec",
      kod: ["vobce"],
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 1,
            "line-color": "#949596",
          },
          minzoom: 10,
          filter: ["==", "$type", "Polygon"],
          koddb: "obec",
        },
        {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 12,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "#949596",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 12,
          koddb: "nazov",
        },
      ],
    },
    {
      nazov: "SK okres",
      kod: ["vokresy"],
      kod_farby: "020",
      kod_ikonky: "006",
      nastavenie_mapy: [
        {
          typ_vrstvy: "line",
          paint: {
            "line-width": 2,
            "line-color": "#3f47db",
          },
          minzoom: 7,
          filter: ["==", "$type", "Polygon"],
          koddb: "okres",
        },
        /* {
          typ_vrstvy: "symbol",
          layout: {
            "text-field": ["to-string", ["get", "nazov"]],
            "text-size": 14,
            "text-font": ["Open Sans Bold"],
            "text-line-height": 1,
          },
          paint: {
            "text-color": "#3f47db",
            "text-halo-color": "#fafaf3",
            "text-halo-width": 1,
            "text-halo-blur": 1,
          },
          minzoom: 7,
          koddb: "nazov",
        }, */
      ],
    },
  ],
});
